const state = {
    collaborators: [
        {
            picture: "https://memod-public.s3.amazonaws.com/insights/Tom.JPG",
            name: "Tom Butler-Bowdon",
            bio: "is the author of nine books including 50 Business Classics, 50 Economics Classics, 50 Psychology Classics, and 50 Philosophy Classics. His 50 Classics series has sold over 500,000 copies and is in 23 languages. Through the Wiley Capstone series Tom has written Introductions to landmark titles such as Plato’s Republic and Sun Tzu’s Art of War. Tom is a graduate of the London School of Economics and the University of Sydney."
        },
        {
            picture: "https://memod-public.s3.amazonaws.com/insights/Karin.JPG",
            name: "Karin Richey",
            bio: "has a degree in Communications and has worked in marketing, communications and e-learning for the past decade. She has non-profit organizations throughout the San Francisco Bay Area tell the story of who they are and why they matter to the world. She attended the Los Angeles Film Studies Center and has written plays, a screenplay, and two children's books. She’s also a big fan of self-help, lifestyle and memoir books."
        },
        {
            picture: "https://memod-public.s3.amazonaws.com/insights/Gabriel.JPG",
            name: "Gabriel Mara",
            bio: "is a writer and audio producer from Allentown, Pennsylvania. He studied Film Production and Journalism at Brooklyn College at the City University of New York. In addition to writing and directing a number of short films, he has produced numerous podcasts and live comedy shows. Gabe whittles away at his enormous reading list by co-hosting a book club podcast called Slow Readers. He lives in Los Angeles, but hates driving."
        },
        {
            picture: "https://memod-public.s3.amazonaws.com/insights/Daniel.JPG",
            name: "Daniel W Reichl",
            bio: "is an audio producer, writer, and editor from Brooklyn, NY and Allentown, PA. He studied English at Penn State University. He created and cohosts the literature comedy podcast Slow Readers with filmmaker and audio producer Gabriel Mara. Daniel also publishes fiction under the name Daniel Gonzalez."
        },
        {
            picture: require("@assets/img/book-insights/authors/cian_traynor.jpg"),
            name: "Cian Traynor",
            bio: "is a writer and editor who has worked for The Irish Times, the BBC, The Financial Times and NME among others. Over the last 15 years, he has interviewed business leaders, scientists, psychologists and some of the biggest names in entertainment. It's a journey that has taken him around the world, gleaning invaluable perspective along the way. Cian is a graduate of University College Dublin and City University London."
        }
    ]
}

const mutations = {
}

const actions = {

}

const getters = {
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
